import React, { useState, useEffect, Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { HelmetProvider } from 'react-helmet-async';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import Navbar from './components/Navbar';
import Loader from './components/Loader';
import Fotter from './components/fotter';
import Home from './pages/Home';
import { RefsProvider } from './Refcontex';
import RouteSEO from './components/RouteSEO';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';

gsap.registerPlugin(ScrollTrigger);
// GSAP's documented fix for iOS Safari: the address bar hiding/showing while
// scrolling fires resize events that otherwise make ScrollTrigger recompute
// pin/scrub positions mid-scroll, which is felt as stutter.
ScrollTrigger.config({ ignoreMobileResize: true });

const Contactuspage = lazy(() => import('./pages/contactuspage'));
const Aboutus = lazy(() => import('./pages/Aboutus'));
const Sevicespage = lazy(() => import('./pages/Sevicespage'));
const Projectpage = lazy(() => import('./pages/projectpage'));
const FileUploader = lazy(() => import('./pages/FileUploader'));
const Ai = lazy(() => import('./pages/ai'));
const Spd = lazy(() => import('./pages/spd'));
const Hubio = lazy(() => import('./pages/Hubio'));
const Unifyx = lazy(() => import('./pages/Unifyx'));
const Fitsage = lazy(() => import('./pages/Fitsage'));
const SpoorthiCRM = lazy(() => import('./pages/SpoorthiCRM'));
const StudentChakra = lazy(() => import('./pages/StudentChakra'));
const Clokam = lazy(() => import('./pages/Clokam'));
const Sevak = lazy(() => import('./pages/Sevak'));
const Shadab = lazy(() => import('./pages/Shadab'));
const Blog = lazy(() => import('./components/blog'));
const BlogDetail = lazy(() => import('./pages/BlogDetail'));
const BlogAdmin = lazy(() => import('./components/BlogAdmin'));
const AdminLogin = lazy(() => import('./pages/AdminLogin'));
const Careers = lazy(() => import('./pages/Careers'));
const JobDetail = lazy(() => import('./pages/JobDetail'));
const CareersAdmin = lazy(() => import('./components/CareersAdmin'));

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const [showNavbar, setShowNavbar] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [showSplitscreen, setShowSplitscreen] = useState(() => {
      return sessionStorage.getItem("splitscreen_shown") ? false : true;
  });
  

  useEffect(() => {
    // Clear stale localStorage data on landing, but keep Supabase auth tokens
    // (prefixed "sb-") so an admin's session survives a page load/refresh.
    Object.keys(localStorage)
      .filter((key) => !key.startsWith('sb-'))
      .forEach((key) => localStorage.removeItem(key));

    // Detect if device is mobile
    const checkMobile = () => {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      const isMobileDevice = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent.toLowerCase());
      const isSmallScreen = window.innerWidth <= 768;
      return isMobileDevice || isSmallScreen;
    };

    const mobile = checkMobile();
    setIsMobile(mobile);

    // On mobile, skip loading animation
    if (mobile) {
      setIsLoading(false);
      setShowNavbar(true);
      document.body.style.cursor = 'default';
    } else {
      // Desktop: show loading animation
      const timer = setTimeout(() => {
        setIsLoading(false);
        document.body.style.cursor = 'default';
      }, 2000);

      const navbarTimer = setTimeout(() => {
        setShowNavbar(true);
      }, showSplitscreen ? 12000: 0);

      return () => {
        clearTimeout(timer);
        clearTimeout(navbarTimer);
      };
    }
  }, []);

  return (
    <HelmetProvider>
      <AuthProvider>
      <Router>
        <RefsProvider>
        <RouteSEO />
        {showNavbar && <Navbar />}
          <Suspense fallback={null}>
          <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/contactus" element={<Contactuspage />} />
                <Route path="/projects/contactus" element={<Contactuspage />} />
                <Route path="/aboutus" element={<Aboutus />} />
                <Route path="/services" element={<Sevicespage />} />
                <Route path="/projects" element={<Projectpage />} />
                <Route path="/ai" element={<Ai />} />
                <Route path="/projects/ai" element={<Ai />} />
                <Route path="/projects/Spd" element={<Spd />} />
                <Route path="/Spd" element={<Spd />} />
                <Route path="/hubio" element={<Hubio />} />
                <Route path="/projects/hubio" element={<Hubio />} />
                <Route path="/unifyx" element={<Unifyx />} />
                <Route path="/projects/unifyx" element={<Unifyx />} />
                <Route path="/fitsage" element={<Fitsage />} />
                <Route path="/projects/fitsage" element={<Fitsage />} />
                <Route path="/spoorthi-crm" element={<SpoorthiCRM />} />
                <Route path="/projects/spoorthi-crm" element={<SpoorthiCRM />} />
                <Route path="/student-chakra" element={<StudentChakra />} />
                <Route path="/projects/student-chakra" element={<StudentChakra />} />
                <Route path="/clokam" element={<Clokam />} />
                <Route path="/projects/clokam" element={<Clokam />} />
                <Route path="/sevak" element={<Sevak />} />
                <Route path="/projects/sevak" element={<Sevak />} />
                <Route path="/shadab" element={<Shadab />} />
                <Route path="/projects/shadab" element={<Shadab />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:blogId" element={<BlogDetail />} />
                <Route path="/careers" element={<Careers />} />
                <Route path="/careers/:slug" element={<JobDetail />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route
                  path="/admin/blog"
                  element={
                    <ProtectedRoute>
                      <BlogAdmin />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/admin/careers"
                  element={
                    <ProtectedRoute>
                      <CareersAdmin />
                    </ProtectedRoute>
                  }
                />
                <Route path="/leads" element={<FileUploader />} />
              </Routes>
          </Suspense>
          {/* <AnimatePresence mode="wait">
            {isLoading ? <Loader /> : (
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/contactus" element={<Contactuspage />} />
                <Route path="/aboutus" element={<Aboutus />} />
                <Route path="/services" element={<Sevicespage />} />
                <Route path="/projects" element={<Projectpage />} />
                <Route path="/leads" element={<FileUploader />} />
              </Routes>
            )}
          </AnimatePresence> */}
          <Fotter />
        </RefsProvider>
      </Router>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
